export default __webpack_public_path__ + "static/telephone-2-0d9e934e25833089674711335d9da315.svg";